import React, { useState } from "react";

import { resolveSlotEntry } from "../../utils/adConfig";
import { AdSlot } from "./AdSlot";
import { YandexAdapter } from "./YandexAdapter";

// Размер — на самом контейнере: блок нулевой высоты РСЯ не считает видимым и не рисует.
const SLOT_STYLE = { width: "100%", minHeight: 250 };

export function NoImageSlot({ isFull, isDesktop, children }) {
    const [noAd, setNoAd] = useState(false);

    if (noAd || !resolveSlotEntry("noimage", { isFull, isDesktop })) {
        return children;
    }

    return (
        <AdSlot
            slot="noimage"
            isFull={isFull}
            isDesktop={isDesktop}
            // Блок стоит на месте картинки статьи: рефреш очистил бы его, как только читатель прокрутит ниже.
            render={(entry) => (
                <YandexAdapter entry={entry} onNoAd={() => setNoAd(true)} style={SLOT_STYLE} refreshable={false} />
            )}
        />
    );
}

export default NoImageSlot;
